module.exports = __webpack_public_path__ + "img/list_3_tc.a86cc1d8.png";